import React, { ReactNode, createContext } from 'react';

export const AutoCompleteOuterElementContext = createContext({});

type AutoCompleteOuterElementContextProps = {
    children: ReactNode;
    value: Omit<React.PropsWithChildren<React.HTMLAttributes<HTMLElement>>, 'children'>;
    divRef: React.LegacyRef<HTMLDivElement>;
};

export const AutocompleteOuterElementContextProvider = ({
    children,
    value,
    divRef,
}: AutoCompleteOuterElementContextProps) => {
    return (
        <div ref={divRef}>
            <AutoCompleteOuterElementContext.Provider value={value}>
                {children}
            </AutoCompleteOuterElementContext.Provider>
        </div>
    );
};
